const permissions = {
  listProtocol: 'PT001',
  createProtocol: 'PT002',
  editProtocol: 'PT003',
  deleteProtocol: 'PT004',
  viewConsoleCatalog: 'CM003',
  addConsole: 'CM004',
  editConsole: 'CM005'
};

export default permissions;
